/**
 * Request-access strings (docs/superpowers/specs/2026-10-17-request-access-design.md §8.7, §8.9; Joni).
 * Never "private", "hidden" or "secret": the UI hides item data on screen but does not keep it secret (U1).
 */
export const requestAccessCopy = {
  button: 'Request access',
  buttonSent: 'Request sent',
  sentCaption: "You'll get a notification if they give you access.",
  inlineLabel: 'No access',
  inlineAccessibleName: 'No access. Open to request access.',
  embedText: "You don't have access to this block",
  embedSent: "Request sent. You'll get a notification if they give you access.",
  deniedBody: 'Ask for access and the owner will get your request, with your name and email address ({email}).',
  shareHeading: 'Access requests ({n})',
  approve: 'Approve',
  approveCanView: 'Approve (can view)',
  approveAs: 'Approve as…',
  canView: 'Can view',
  canEdit: 'Can edit',
  decline: 'Decline',
  homeHeading: 'Waiting on you',
  homeRow: '{name} asked for access to {title}',
  showAll: 'Show all {n}',
  showFewer: 'Show fewer',
  review: 'Review',
  approvedView: '{name} can now view {title}',
  approvedEdit: '{name} can now edit {title}',
  declined: "Declined {name}'s request",
  undo: 'Undo',
  alreadyHandled: 'Someone already answered this request.',
  itemGone: 'This item no longer exists.',
  rateLimited: "You've sent a lot of requests today. Try again tomorrow.",
  /** Requester only (§8.9 #1) */
  failed: "Couldn't send your request.",
  /** Approver failures: approve, decline, undo (§8.9 #1) */
  approverFailed: "Couldn't update this request.",
  retry: 'Retry',
} as const

/** Fill `{name}`-style placeholders. An unknown placeholder stays visible rather than turning blank. */
export const fillCopy = (template: string, vars: Record<string, string | number>) =>
  template.replace(/\{(\w+)\}/g, (match, key: string) => (key in vars ? String(vars[key]) : match))
